import { typographyStyles } from "@newsela/angelou";

import {
  bodyFontSizeMapping,
  bodyLineHeight,
} from "@/view/constants/styles/accessibleFontSizeMapping/accessibleFontSizeMapping.style";

const { textLObj } = typographyStyles;

export const rootCss = () => ({
  fontFamily: textLObj.fontFamily,
  fontSize: bodyFontSizeMapping.medium,
  lineHeight: bodyLineHeight,
  marginBottom: "30px",
});
